// extracted by mini-css-extract-plugin
module.exports = {"root":"_27b8214","white":"_163120d","green":"_efa99ea","red":"_b3885a6","steam":"_da40daa","gray":"_f184f38"};